import React from "react"
import {Modal,ModalBody,ModalHeader,ModalFooter} from "reactstrap"
export default (props)=>{
 
return (<Modal  style={{zIndex:5000}}   isOpen={props.isOpen} >
    <ModalHeader>{props.title}</ModalHeader>
    <ModalBody style={{textAlign:"left"}}>{props.message}</ModalBody>
    <ModalFooter><button onClick={props.onClose} className="btn btn-success">OK</button></ModalFooter>
</Modal> );

}